import ajuda from './ajuda/routes'
import perfil from './perfil/routes'
import suporte from './suporte/routes'

export default [
    ...ajuda,
    ...perfil,
    ...suporte,
]
